/* mb-gallery-peek.js
 * Mobile PDP gallery → centred CSS scroll-snap carousel with a peek of the
 * previous AND next photo on both sides + a clear white gap, plus pagination
 * dots and a single Mayberry/Mayfield-style zoom button (bottom-right).
 *
 * The CENTRING is done purely in CSS (sections/main-product.liquid:
 * scroll-snap-align:center + ::before/::after spacer pseudo-elements). That is
 * mathematically exact and applies the instant the page paints — no Swiper, no
 * measurement race (the old Swiper build measured slide width before the 75vw
 * CSS + images were ready, leaving the photo left-aligned with a peek on the
 * right only). This script only ADDS the dots (synced to scroll position) and
 * the single zoom button on top. Desktop (>=750px) keeps Dawn's own gallery.
 */
(function () {
  'use strict';
  var MOBILE = '(max-width: 749px)';
  function isMobile() { return window.matchMedia(MOBILE).matches; }
  function items(list) { return Array.prototype.slice.call(list.querySelectorAll('.product__media-item')); }
  /* echte foto's, zonder de loop-klonen */
  function realItems(list) { return Array.prototype.slice.call(list.querySelectorAll('.product__media-item:not(.mb-clone)')); }

  /* ---- LOOP: kloon de LAATSTE foto vóór de eerste en de EERSTE ná de laatste,
     zodat elke foto (incl. de eerste/laatste) een buur-peek aan beide kanten heeft,
     net als bymayfield/bymayberry. De klonen zijn aria-hidden en tellen niet mee
     voor de dots. Bij het rusten op een kloon "teleporteren" we onzichtbaar naar de
     echte foto (oneindige loop). ---- */
  function centerEl(list, el, smooth) {
    var d = (el.getBoundingClientRect().left + el.getBoundingClientRect().width / 2)
          - (list.getBoundingClientRect().left + list.clientWidth / 2);
    if (smooth) { try { list.scrollTo({ left: list.scrollLeft + d, behavior: 'smooth' }); return; } catch (e) {} }
    list.scrollLeft += d;
  }
  function setupLoop(list) {
    if (list.__mbLoopDone) return;
    var its = realItems(list);
    if (its.length < 2) return;
    list.__mbLoopDone = true;
    function mkClone(node, van) {
      var c = node.cloneNode(true);
      c.classList.add('mb-clone');
      c.classList.remove('is-active');
      c.setAttribute('aria-hidden', 'true');
      c.setAttribute('data-mb-clone-of', van);
      c.removeAttribute('id');
      Array.prototype.forEach.call(c.querySelectorAll('[id]'), function (e) { e.removeAttribute('id'); });
      /* data-media-id van de kloon strippen: Dawn zoekt de variantfoto met
         querySelector('[data-media-id="..."]') en pakt het eerste resultaat in de DOM.
         De kloon staat vóór de echte foto, dus zonder dit markeert Dawn de kloon als
         actief en springt de galerij naar de verkeerde foto. */
      c.removeAttribute('data-media-id');
      Array.prototype.forEach.call(c.querySelectorAll('[data-media-id]'), function (e) { e.removeAttribute('data-media-id'); });
      return c;
    }
    list.insertBefore(mkClone(its[its.length - 1], 'last'), its[0]); /* laatste foto vóór de eerste */
    list.appendChild(mkClone(its[0], 'first'));                      /* eerste foto ná de laatste */
    /* center het eerste ECHTE dia (index 1, ná de voorgekloonde laatste). Scroll-snap
       even uitzetten, anders snapt de browser meteen terug naar de kloon op index 0. */
    function reCenterFirst() {
      if (list.__mbUserMoved) return;
      var all = items(list);
      if (!all[1]) return;
      var prev = list.style.scrollSnapType;
      list.style.scrollSnapType = 'none';
      centerEl(list, all[1], false);
      window.requestAnimationFrame(function () { list.style.scrollSnapType = prev || ''; });
    }
        /* Zodra de bezoeker zelf veegt/sleept mag er NIETS meer hercentreren.
       Anders springt de galerij terug naar foto 1 zodra een lui geladen foto
       verderop binnenkomt en z'n load-event afvuurt. */
    var markMoved = function () { list.__mbUserMoved = true; };
    ['pointerdown', 'touchstart', 'wheel', 'keydown', 'mousedown'].forEach(function (ev) {
      list.addEventListener(ev, markMoved, { passive: true });
    });
    
    window.requestAnimationFrame(reCenterFirst);
    window.setTimeout(reCenterFirst, 240);
    window.setTimeout(reCenterFirst, 600);
    window.addEventListener('load', reCenterFirst, { once: true });
    Array.prototype.forEach.call(list.querySelectorAll('img'), function (img) {
      if (!img.complete) img.addEventListener('load', reCenterFirst, { once: true });
    });
    /* teleport: rust je op een kloon, spring naar de echte foto */
    var tt;
    list.__mbLoopScroll = function () {
      window.clearTimeout(tt);
      tt = window.setTimeout(function () {
        var all = items(list);
        if (all.length < 3) return;
        var cur = all[centeredIndex(list, all)];
        if (!cur || !cur.classList.contains('mb-clone')) return;
        var reals = realItems(list);
        if (!reals.length) return;
        if (cur.getAttribute('data-mb-clone-of') === 'last') centerEl(list, reals[reals.length - 1], false);
        else centerEl(list, reals[0], false);
      }, 140);
    };
    list.addEventListener('scroll', list.__mbLoopScroll, { passive: true });
  }
  function teardownLoop(list) {
    if (!list.__mbLoopDone) return;
    list.__mbLoopDone = false;
    if (list.__mbLoopScroll) { list.removeEventListener('scroll', list.__mbLoopScroll); list.__mbLoopScroll = null; }
    Array.prototype.forEach.call(list.querySelectorAll('.mb-clone'), function (c) { c.remove(); });
  }

  /* Which photo is currently centred in the scroller? */
  function centeredIndex(list, its) {
    var rect = list.getBoundingClientRect();
    var center = rect.left + rect.width / 2;
    var best = 0, bestD = Infinity;
    its.forEach(function (it, i) {
      var r = it.getBoundingClientRect();
      var d = Math.abs((r.left + r.width / 2) - center);
      if (d < bestD) { bestD = d; best = i; }
    });
    return best;
  }

  /* ---- Pagination dots (one per photo), synced to the centred slide ---- */
  function buildDots(list) {
    if (list.__mbDots) return;
    var its = realItems(list);
    if (its.length < 2) return;

    var nav = document.createElement('div');
    nav.className = 'mb-snap-dots';
    its.forEach(function (it, i) {
      var d = document.createElement('button');
      d.type = 'button';
      d.className = 'mb-snap-dot';
      d.setAttribute('aria-label', 'Foto ' + (i + 1));
      d.addEventListener('click', function () {
        try { it.scrollIntoView({ behavior: 'smooth', inline: 'center', block: 'nearest' }); }
        catch (e) { it.scrollIntoView(); }
      });
      nav.appendChild(d);
    });
    /* dots live BELOW the whole gallery (after the slider-component) */
    var sc = list.closest('slider-component') || list.parentNode;
    if (sc && sc.parentNode) sc.parentNode.insertBefore(nav, sc.nextSibling);
    else if (list.parentNode) list.parentNode.insertBefore(nav, list.nextSibling);
    list.__mbDots = nav;

    function syncDots() {
      var idx = centeredIndex(list, realItems(list));
      var dots = nav.querySelectorAll('.mb-snap-dot');
      for (var i = 0; i < dots.length; i++) {
        dots[i].classList.toggle('is-active', i === idx);
      }
    }
    var raf = 0;
    list.__mbDotScroll = function () {
      if (raf) return;
      raf = window.requestAnimationFrame(function () { raf = 0; syncDots(); });
    };
    list.addEventListener('scroll', list.__mbDotScroll, { passive: true });
    syncDots();
  }

  function teardownDots(list) {
    if (list.__mbDotScroll) { list.removeEventListener('scroll', list.__mbDotScroll); list.__mbDotScroll = null; }
    if (list.__mbDots) { list.__mbDots.remove(); list.__mbDots = null; }
  }

  function sync(list) {
    if (isMobile()) { setupLoop(list); buildDots(list); }
    else { teardownDots(list); teardownLoop(list); }
  }

  /* ---- Single Mayberry-style ZOOM button: white magnifier circle overlaid
     bottom-right ON the centred photo. Tap opens Dawn's lightbox for whichever
     slide is currently centred. One button + one handler; CSS hides it on
     desktop. Anchored to the slider-component (forced position:relative). ---- */
  function addZoom(list) {
    if (list.__mbZoomBtn) return;
    if (items(list).length < 1) return;
    var host = list.closest('slider-component') || list.parentElement;
    if (!host) return;
    if (getComputedStyle(host).position === 'static') host.style.position = 'relative';
    var zoom = document.createElement('button');
    zoom.type = 'button';
    zoom.className = 'mb-gal-zoom2';
    zoom.setAttribute('aria-label', 'Vergroot foto');
    zoom.innerHTML = '<svg viewBox="0 0 24 24" width="20" height="20" aria-hidden="true"><circle cx="10.5" cy="10.5" r="6.5" fill="none" stroke="currentColor" stroke-width="2"/><path d="M20 20 L15.5 15.5" stroke="currentColor" stroke-width="2" stroke-linecap="round"/></svg>';
    zoom.addEventListener('click', function (e) {
      e.preventDefault(); e.stopPropagation();
      var arr = realItems(list);
      if (!arr.length) return;
      var best = arr[centeredIndex(list, arr)];
      var b = best && best.querySelector('.product__media-toggle, modal-opener button, .product__modal-opener button');
      if (b) b.click();
    });
    list.__mbZoomBtn = zoom;
    host.appendChild(zoom);
  }

  /* Tap op een NIET-gecentreerde peek-foto (links/rechts) → schuif 'm naar het
     midden, net als bymayberry/mayfield. Capture-fase zodat we Dawn's lightbox
     onderscheppen vóór die opent. De gecentreerde foto laten we door (zoom-knop /
     Dawn-lightbox handelt die af). Klonen → scrollen + teleport regelt de echte. */
  function smoothCenter(list, item) {
    /* Snap AAN laten (uitzetten + terugzetten liet 'm terugsnappen). Geverifieerd:
       scrollBy met snap aan centreert de getikte foto correct. Smooth voor de UX;
       een instant correctie ná de animatie garandeert dat 'ie exact gecentreerd
       landt (smooth kan op snap-mandatory net naast het snappunt eindigen). */
    function delta() {
      return (item.getBoundingClientRect().left + item.getBoundingClientRect().width / 2)
           - (list.getBoundingClientRect().left + list.clientWidth / 2);
    }
    try { list.scrollBy({ left: delta(), behavior: 'smooth' }); }
    catch (e) { list.scrollLeft += delta(); }
    window.setTimeout(function () { var d = delta(); if (Math.abs(d) > 2) list.scrollLeft += d; }, 420);
  }
  function bindTapToCenter(list) {
    if (list.__mbTapBound) return;
    list.__mbTapBound = true;
    var sx = 0, sy = 0, sScroll = 0, moved = false, suppress = false;
    /* pointer-events i.p.v. click: betrouwbaarder op touch. We onderscheiden een
       TIK (nauwelijks beweging + geen scroll) van een SWIPE, en centreren alleen
       bij een tik op een niet-gecentreerde foto. */
    list.addEventListener('pointerdown', function (e) {
      sx = e.clientX; sy = e.clientY; sScroll = list.scrollLeft; moved = false;
    }, true);
    list.addEventListener('pointermove', function (e) {
      if (Math.abs(e.clientX - sx) > 8 || Math.abs(e.clientY - sy) > 8) moved = true;
    }, true);
    list.addEventListener('pointerup', function (e) {
      if (!isMobile()) return;
      if (moved || Math.abs(list.scrollLeft - sScroll) > 5) return; /* het was een swipe */
      var item = e.target.closest && e.target.closest('.product__media-item');
      if (!item) return;
      var all = items(list);
      if (all.indexOf(item) === centeredIndex(list, all)) return; /* gecentreerd → laat zoom/lightbox door */
      /* tikt op een loop-kloon? → centreer de ECHTE foto die 'ie representeert
         (cloneLast = eerste kind → echte laatste; cloneFirst = laatste kind → echte
         eerste). Voorkomt botsing met de teleport én geeft correcte wrap-around. */
      if (item.classList.contains('mb-clone')) {
        var reals = realItems(list);
        item = (item === all[0]) ? reals[reals.length - 1] : reals[0];
      }
      if (!item) return;
      suppress = true; window.setTimeout(function () { suppress = false; }, 500);
      smoothCenter(list, item);
    }, true);
    /* onderdruk de click die ná een tik-op-peek zou volgen (Dawn-lightbox) */
    list.addEventListener('click', function (e) {
      if (suppress) { e.preventDefault(); e.stopPropagation(); }
    }, true);
  }

  /* Variant change → scroll the gallery to that variant's image (centred). */
  function bindVariant(list) {
    if (list.__mbVarBound) return;
    list.__mbVarBound = true;
    var section = list.closest('.shopify-section') || document;
    function centreActive() {
      var active = list.querySelector('.product__media-item.is-active:not(.mb-clone)')
                || list.querySelector('.product__media-item:not(.mb-clone)');
      if (!active) return;
      /* klonen opnieuw rangschikken: Dawn heeft de actieve foto vooraan gezet, dus de
         oude kloon-volgorde klopt niet meer en de buur-peek zou fout staan. */
      teardownLoop(list);
      setupLoop(list);
      var prev = list.style.scrollSnapType;
      list.style.scrollSnapType = 'none';
      centerEl(list, active, false);
      window.requestAnimationFrame(function () { list.style.scrollSnapType = prev || ''; });
    }
    section.addEventListener('change', function (e) {
      if (!isMobile()) return;
      if (e.target && e.target.closest && e.target.closest('variant-selects, variant-radios, .product-form__input')) {
        window.clearTimeout(list.__mbVarT1);
        window.clearTimeout(list.__mbVarT2);
        list.__mbVarT1 = window.setTimeout(centreActive, 320);
        list.__mbVarT2 = window.setTimeout(centreActive, 750);
      }
    });
  }

  /* "Your own words" testimonials → prev/next arrows to scroll the
     native review carousel (.mb-com__slider). */
  function setupTestimonials() {
    document.querySelectorAll('.mb-com__slider').forEach(function (slider) {
      if (slider.__mbComInit) return;
      if (slider.scrollWidth <= slider.clientWidth + 10) return;
      slider.__mbComInit = true;
      var wrap = slider.closest('.mb-com__slider-wrap') || slider.parentElement;
      if (getComputedStyle(wrap).position === 'static') wrap.style.position = 'relative';
      function arrow(cls, label, dPath) {
        var b = document.createElement('button');
        b.type = 'button'; b.className = 'mb-com-nav ' + cls; b.setAttribute('aria-label', label);
        b.innerHTML = '<svg viewBox="0 0 24 24" width="18" height="18" aria-hidden="true"><path d="' + dPath + '" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>';
        return b;
      }
      function step() { var c = slider.querySelector('.mb-com__card, .mb-com__panel'); return (c ? c.getBoundingClientRect().width : 300) + 26; }
      var prev = arrow('mb-com-prev', 'Vorige review', 'M15 5 L8 12 L15 19');
      var next = arrow('mb-com-next', 'Volgende review', 'M9 5 L16 12 L9 19');
      prev.addEventListener('click', function () { slider.scrollBy({ left: -step(), behavior: 'smooth' }); });
      next.addEventListener('click', function () { slider.scrollBy({ left: step(), behavior: 'smooth' }); });
      wrap.appendChild(prev); wrap.appendChild(next);
    });
  }

  function run() {
    document.querySelectorAll('.product__media-list').forEach(sync);
    setupTestimonials();
  }
  function init() {
    document.querySelectorAll('.product__media-list').forEach(function (l) { bindVariant(l); addZoom(l); bindTapToCenter(l); });
    run();
  }

  if (document.readyState !== 'loading') init(); else document.addEventListener('DOMContentLoaded', init);
  window.addEventListener('resize', run);
  document.addEventListener('shopify:section:load', init);
})();
